import { render } from "./ScreenshotsSection.vue?vue&type=template&id=319df345&scoped=true"
import script from "./ScreenshotsSection.vue?vue&type=script&lang=js"
export * from "./ScreenshotsSection.vue?vue&type=script&lang=js"

import "./ScreenshotsSection.vue?vue&type=style&index=0&id=319df345&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319df345"]])

export default __exports__